import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import background_image from "./background_image.jpg";
import Link from "nekrasovka-ui/Link";
import { useWindowDimensions } from "containers/WindowDimensions";

import Search from "containers/Search";
import Section from "components/Section";
import { connect } from "react-redux";
import persons from "modules/persons";
import search from "modules/search";
import { withRouter } from "react-router-dom";
const { fetchPersons, fetchFilterPersons } = persons.actions;
const { queryUpdate } = search.actions;

const NavigatorContainer = styled.div`
  padding: 100px 20px 40px;

  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url(${background_image}) no-repeat center center;
  background-size: cover;

  @media (max-width: 768px) {
    padding-top: 50px;
    padding-bottom: 20px;
  }
`;

const SearchHint = styled.div`
  line-height: 16px;
  font-size: 15px;
  color: #999999;
  margin-top: 10px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Navigation = styled.div`
  border-top: 1px solid #c4c4c4;
  padding: 20px 0;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    margin-top: 30px;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @media (max-width: 568px) {
    margin-top: 20px;
    padding-bottom: 5px;
    border-bottom: 1px solid #c4c4c4;
  }
`;

const NavigationItem = styled.span`
  font-family: Rubik, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;

  color: ${props =>
    props.color
      ? props.active
        ? "#ffad20"
        : "#ffffff"
      : props.theme.colors.alternateTextColor};
  cursor: ${props => (props.color ? "pointer" : "")};

  @media (max-width: 768px) {
    margin-right: 15px;
    margin-bottom: 15px;
  }
`;

const StyledLink = styled(Link)`
  font-family: Rubik, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 57px;
  margin: 0;

  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 21px;
  }
`;

const Navigator = ({
  letters,
  letter,
  fetchFilterPersons,
  fetchPersons,
  history,
  history: {
    location: { pathname }
  }
}) => {
  const { width } = useWindowDimensions();
  const [lettersState, setLettersState] = useState([
    {
      letter: "Все:",
      value: "true"
    }
  ]);

  useEffect(() => {
    pathname === "/persons" ? fetchFilterPersons("Все:") : fetchPersons();
  }, []);

  useEffect(() => {
    letter && pathname !== "/persons" && history.push("/persons");
  }, [letter]);

  useEffect(() => {
    lettersState.length === 1 && letters.length && getNewLettersArray(letters);
  }, [letters]);

  const getNewLettersArray = letters => {
    const array = [...lettersState, ...letters];
    setLettersState(array);
  };

  const handleLetterClick = selectedLetter => {
    if (selectedLetter === letter) {
      history.push("/");
    } else {
      fetchFilterPersons(selectedLetter);
    }
  };

  return (
    <NavigatorContainer className="background_image">
      <Section>
        <StyledLink to="/">
          Сводный указатель личных имен в дореволюционной периодике
        </StyledLink>
        {width <= 568 && (
          <Fragment>
            <Search />
            <SearchHint>Например: Голицын Василий Васильевич</SearchHint>
          </Fragment>
        )}
        <Navigation>
          {lettersState.map((item, index) => (
            <NavigationItem
              key={index}
              color={item.value}
              active={letter === item.letter}
              onClick={() => item.value && handleLetterClick(item.letter)}
            >
              {item.letter}
            </NavigationItem>
          ))}
        </Navigation>
        {width > 568 && (
          <Fragment>
            <Search />
            <SearchHint>Например: Голицын Василий Васильевич</SearchHint>
          </Fragment>
        )}
      </Section>
    </NavigatorContainer>
  );
};

const mapStateToProps = ({
  persons: { letters, letter },
  search: { query }
}) => ({
  letters,
  letter,
  query
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      fetchPersons,
      fetchFilterPersons,
      queryUpdate
    }
  )(Navigator)
);



// WEBPACK FOOTER //
// ./src/components/Navigator/index.js